import { z } from 'zod';

export const ALERT_CATEGORY_VALUES = [
  'overtime',
  'interval',
  'leave',
  'irregular',
  'all',
] as const;

export type AlertCategory = (typeof ALERT_CATEGORY_VALUES)[number];

export const AlertSearchSchema = z.object({
  category: z.enum(ALERT_CATEGORY_VALUES).default('all'),
  freeText: z.string().optional(),
  /** "all" または勤務地名（CLOCKING_RECORDS_DEMO_WORKPLACES） */
  workplace: z.string().default('all'),
  severity: z.enum(['all', 'info', 'warning', 'critical']).default('all'),
  resolved: z.enum(['all', 'resolved', 'unresolved']).default('unresolved'),
  pageIndex: z.coerce.number().default(0),
  pageSize: z.coerce.number().default(100),
});

export type AlertSearchParams = z.infer<typeof AlertSearchSchema>;
